import styled from "styled-components/macro";

import TabSelector from "components/TabSelector";

const MobileTransactionSaleTabSelector = styled(TabSelector)`
  text-transform: none;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  padding-left: 6px;
  padding-right: 6px;
  width: 100%;
  ${({ selected, color, theme, bold }) => {
    const borderHeight = bold ? "4px" : "2px";
    return `
      font-weight: ${bold ? "700" : "300"};
      margin-left: ${theme.space[3]}px;
      border-bottom: ${borderHeight} solid ${
        selected ? theme.colors[color] || theme.colors.primary : "transparent"
      };
    `;
  }};
`;

export default MobileTransactionSaleTabSelector;
